export default __webpack_public_path__ + "static/media/feastlogo.a0fcc58b.png";